import { inject } from '@angular/core';
import type { CanActivateFn, Route } from '@angular/router';
import { Router } from '@angular/router';
import { WorkflowPermissions } from '@backoffice/shared/bo/util-permissions';
import { ngxPermissionsGuard } from 'ngx-permissions';

const workflowEnergySourceGuard: CanActivateFn = (route) => {
  const energySource = route.paramMap.get('energySource');

  if (energySource === 'power' || energySource === 'gas') {
    return true;
  }

  return inject(Router).createUrlTree(['/notfound']);
};

const workflowDiagramRouteData = {
  permissions: {
    only: [WorkflowPermissions.workflowView],
  },
};

export const workflowDiagramComponentRoute: Route = {
  path: 'workflow-diagram',
  children: [
    {
      path: ':energySource/:id',
      loadComponent: () =>
        import('./workflow-diagram.component').then(
          (m) => m.WorkflowDiagramComponent,
        ),
      canActivate: [ngxPermissionsGuard, workflowEnergySourceGuard],
      data: workflowDiagramRouteData,
    },
    {
      path: ':id',
      redirectTo: 'power/:id',
      pathMatch: 'full',
    },
  ],
};
